<template>
  <div class="cnfltd-loading-state">
    <a-spin size="large" />
    <p class="cnfltd-loading-message">{{ message }}</p>
  </div>
</template>

<script setup lang="ts">
// Props
interface Props {
  message?: string
}

withDefaults(defineProps<Props>(), {
  message: 'Searching for domains...'
})
</script>

<style scoped>
.cnfltd-loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
}

.cnfltd-loading-message {
  margin-top: 1rem;
  font-size: 1rem;
  color: #666;
}
</style>
